document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.pd');
  if (!root) return;

  var dataEl = document.getElementById('pd-variants-data');
  if (!dataEl) return;

  var variants = JSON.parse(dataEl.textContent);
  var colorIndex = window.pdColorIndex;
  var sizeIndex = window.pdSizeIndex;

  var swatches = root.querySelectorAll('.pd__swatch');
  var sizeSelect = root.querySelector('.pd__size-select');
  var hiddenInput = document.getElementById('pd-variant-id');
  var priceEl = document.getElementById('pd-price');
  var colorLabel = document.getElementById('pd-color-label');
  var buyBtn = document.getElementById('pd-buy-btn');
  var mediaContainer = root.querySelector('.pd__media');

  var notifyBox = document.getElementById('pd-notify');
  var notifyText = document.getElementById('pd-notify-text');
  var notifyTags = document.getElementById('pd-notify-tags');
  var productHandle = notifyBox ? notifyBox.getAttribute('data-product-handle') : '';
  var productTitle = notifyBox ? notifyBox.getAttribute('data-product-title') : '';

  var currentVariant = variants.find(function (v) {
    return String(v.id) === String(hiddenInput.value);
  });

  var selectedColor = currentVariant && colorIndex > -1 ? currentVariant.options[colorIndex] : null;
  var selectedSize = currentVariant && sizeIndex > -1 ? currentVariant.options[sizeIndex] : null;

  // ---- Media reordering by color ----
  var colorMedia = {};
  if (mediaContainer) {
    try {
      colorMedia = JSON.parse(mediaContainer.getAttribute('data-color-media') || '{}');
    } catch (e) {
      colorMedia = {};
    }
  }

  function reorderMedia(color) {
    if (!mediaContainer || !color || !colorMedia[color]) return;

    var desiredImageOrder = (colorMedia[color] || []).slice();

    // Then every other color's photos, in their defined order
    Object.keys(colorMedia).forEach(function (key) {
      if (key !== color && key !== '_shared') {
        desiredImageOrder = desiredImageOrder.concat(colorMedia[key] || []);
      }
    });

    // Untagged/shared photos go last
    desiredImageOrder = desiredImageOrder.concat(colorMedia['_shared'] || []);

    if (desiredImageOrder.length === 0) return;

    var items = Array.prototype.slice.call(mediaContainer.querySelectorAll('.pd__media-item'));

    // Build a lookup from image src -> item node (only for items containing an <img>)
    var bySrc = {};
    var nonImageItems = [];
    items.forEach(function (item) {
      var img = item.querySelector('.pd__media-image');
      if (img) {
        bySrc[img.getAttribute('src')] = item;
      } else {
        nonImageItems.push(item);
      }
    });

    var fragment = document.createDocumentFragment();
    var used = {};

    desiredImageOrder.forEach(function (src) {
      var item = bySrc[src];
      if (item && !used[src]) {
        fragment.appendChild(item);
        used[src] = true;
      }
    });

    // Append any images not covered by the color/shared mapping (safety net)
    items.forEach(function (item) {
      var img = item.querySelector('.pd__media-image');
      if (img) {
        var src = img.getAttribute('src');
        if (!used[src]) {
          fragment.appendChild(item);
          used[src] = true;
        }
      }
    });

    // Videos / external videos always go after images, in original order
    nonImageItems.forEach(function (item) {
      fragment.appendChild(item);
    });

    mediaContainer.appendChild(fragment);
  }

  function findVariant(color, size) {
    return variants.find(function (v) {
      var colorMatch = colorIndex === -1 || v.options[colorIndex] === color;
      var sizeMatch = sizeIndex === -1 || v.options[sizeIndex] === size;
      return colorMatch && sizeMatch;
    });
  }

  function slugify(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  function updateNotifyBox(variant) {
    if (!notifyBox) return;

    var isUnavailable = !variant || !variant.available;
    notifyBox.hidden = !isUnavailable;

    if (isUnavailable) {
      var descriptors = [];
      if (selectedColor) descriptors.push(selectedColor);
      if (selectedSize) descriptors.push(selectedSize);
      var descriptorText = descriptors.length ? ' (' + descriptors.join(', ') + ')' : '';

      if (notifyText) {
        notifyText.textContent = 'Sold out' + descriptorText + '. Want us to email you when it\'s back?';
      }

      if (notifyTags) {
        var tagParts = ['restock-request', slugify(productHandle)];
        if (selectedColor) tagParts.push(slugify(selectedColor));
        if (selectedSize) tagParts.push(slugify(selectedSize));
        notifyTags.value = tagParts.join('-');
      }
    }
  }

  function updateUI() {
    var variant = findVariant(selectedColor, selectedSize);

    if (variant) {
      hiddenInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }
    } else if (buyBtn) {
      buyBtn.disabled = true;
      buyBtn.textContent = 'Unavailable';
    }

    if (colorLabel) colorLabel.textContent = selectedColor || '';

    swatches.forEach(function (sw) {
      sw.classList.toggle('is-active', sw.getAttribute('data-color') === selectedColor);
    });

    if (sizeSelect && sizeIndex > -1) {
      Array.prototype.forEach.call(sizeSelect.options, function (opt) {
        var v = findVariant(selectedColor, opt.value);
        var available = v ? v.available : true;
        opt.disabled = !available;
        opt.textContent = available ? opt.value : opt.value + ' - Sold out';
      });
    }

    updateNotifyBox(variant);
  }

  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      selectedColor = sw.getAttribute('data-color');
      updateUI();
      reorderMedia(selectedColor);

      // Reset scroll position so the swatch's actual first photo is what's shown,
      // rather than whatever photo now occupies the previous scroll position.
      if (mediaContainer) {
        mediaContainer.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        mediaContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  if (sizeSelect) {
    if (selectedSize) sizeSelect.value = selectedSize;
    sizeSelect.addEventListener('change', function () {
      selectedSize = sizeSelect.value;
      updateUI();
    });
  }

  updateUI();

  // Reorder on initial load to match the default/selected color
  var defaultColor = mediaContainer ? mediaContainer.getAttribute('data-default-color') : null;
  if (defaultColor) {
    reorderMedia(defaultColor);
  }
});
